import { render } from "./repricing.vue?vue&type=template&id=df421eda"
import script from "./repricing.vue?vue&type=script&lang=js"
export * from "./repricing.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1941686567/src/amplify-vue-poc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__